import React, { Component } from 'react';
import { AeMaxPrice } from '~/Api/User/ProductGroup/AeMaxPrice';
import { formatCountriesError } from '~/UI';

import styles from './styles.less';

interface Props {
	aeMaxPrice: AeMaxPrice;
}

export default class Calculation extends Component<Props> {
	render() {
		const {
			aeMaxPrice: { finalCalculation },
		} = this.props;

		return (
			<div className={styles.container}>
				<div>
					<p className={styles.name}>Internation reference prices:</p>
					<p className={styles.value}>{finalCalculation.internationalReferencePrices?.roundedHumanFormat()}</p>
				</div>
				<div>
					<p className={styles.name}>Proposed CIF price to UAE:</p>
					<p className={styles.value}>{finalCalculation.proposedCifPrice?.roundedHumanFormat()}</p>
				</div>
				<div>
					<p className={styles.name}>Country of origin price:</p>
					<p className={styles.value}>{finalCalculation.countryOfOriginExFactoryPrice?.roundedHumanFormat()}</p>
				</div>
				<div>
					<p className={styles.highlightedName}>Final price:</p>
					<p className={styles.highlightedValue}>{finalCalculation.finalPrice?.roundedHumanFormat()}</p>
				</div>

				{finalCalculation.emptyResultReason.length > 0 ? this.renderEmptyResultReason() : null}
			</div>
		);
	}

	renderEmptyResultReason() {
		const {
			aeMaxPrice: { finalCalculation },
		} = this.props;
		const countryError = finalCalculation.findAtMostOneProductPerCountryError();

		if (finalCalculation.hasProductSettingsMissingError()) {
			return <p className={styles.error}>Some products settings are missing</p>;
		}
		if (finalCalculation.hasReferenceCountryProductMissingError()) {
			return <p className={styles.error}>Calculation requires at least one reference country product</p>;
		}
		if (countryError !== null) {
			return (
				<p className={styles.error}>
					Calculation requires at most one product for each country
					{formatCountriesError(countryError.duplicateCountries)}
				</p>
			);
		}
		if (finalCalculation.hasRequiredReferenceSettingsError()) {
			return <p className={styles.error}>Calculation requires reference settings</p>;
		}
		return null;
	}
}
